import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/blockchainApi'
import {
  getAllHistoriesSuccess,
  getAllHistoriesFailed,
  GET_ALL_HISTORIES_START,
} from '../../actions/common'

const getAllHistoriesApi = (props) => {
  const uri = `/api/history/all`
  return api.get(uri, props)
}

function* doGetAllHistories(action) {
  try {
    const response = yield call(getAllHistoriesApi, action?.payload)
    yield put(getAllHistoriesSuccess(response))

    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getAllHistoriesFailed())

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetAllHistories() {
  yield takeLatest(GET_ALL_HISTORIES_START, doGetAllHistories)
}
